var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 24,
    viewBox: "0 0 120 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.212 4.24052V16.2399L97.374 4.23135L95.9258 4.22924V18.8382H97.5503V7.10463L106.211 18.8481L107.841 18.8495V4.24052H106.212ZM87.4752 3.90137C83.3673 3.90137 80.4961 7.04329 80.4961 11.5411C80.4961 16.046 83.3673 19.1872 87.4752 19.1872C91.5788 19.1872 94.4408 16.046 94.4408 11.5411C94.4408 7.04329 91.5795 3.90137 87.4752 3.90137ZM87.4752 17.6395C84.3459 17.6395 82.1524 15.1315 82.1524 11.5411C82.1524 7.95357 84.3459 5.44553 87.4752 5.44553C90.6002 5.44553 92.7796 7.95357 92.7796 11.5411C92.7803 15.1315 90.6002 17.6395 87.4752 17.6395ZM111.307 17.4202V12.0149H119.349V10.5843H111.307V5.65988H119.896V4.23065H109.668V18.8509H119.996V17.4202H111.307Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9165 18.8629L71.2466 12.5226L66.5781 18.8629H64.6546L70.2714 11.2027L65.1425 4.24054H67.0653L71.2466 9.91941L75.4229 4.24054H77.3443L72.2189 11.2027L77.8372 18.8629H75.9165ZM50.205 11.7555C49.9149 11.5098 49.5928 11.3046 49.2475 11.1456C50.3086 10.5695 51.0046 9.48084 51.0046 8.21801C51.0046 7.28234 50.6598 4.24054 46.2515 4.24054H40.3138V10.5441H38.3353C37.9711 11.0257 37.617 11.5149 37.2734 12.0114H40.3138V18.8615L46.2515 18.8622C49.4681 18.8622 51.4664 17.2285 51.4664 14.5935C51.4664 13.4428 51.0314 12.4634 50.205 11.7555ZM41.9553 5.76637H46.2515C47.4149 5.76637 49.3617 6.05617 49.3617 8.09038C49.3617 9.6282 48.2272 10.5448 46.2515 10.5448H41.9553V5.76637ZM46.2508 17.3371H41.9546V12.0136H46.2508C47.8803 12.0136 49.8285 12.4634 49.8285 14.5618C49.8292 16.9753 47.5884 17.3371 46.2508 17.3371Z",
    fill: "#177D3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1897 3.90259C55.0832 3.90259 52.212 7.04451 52.212 11.5423C52.212 16.0472 55.0825 19.187 59.1897 19.187C63.2933 19.187 66.1553 16.0472 66.1553 11.5423C66.1553 7.04451 63.2933 3.90259 59.1897 3.90259ZM59.1897 17.64C56.0604 17.64 53.869 15.132 53.869 11.5423C53.869 7.95479 56.0604 5.44746 59.1897 5.44746C62.314 5.44746 64.4941 7.95479 64.4941 11.5423C64.4941 15.132 62.314 17.64 59.1897 17.64ZM39.5153 18.8613L33.8942 11.2018L39.0231 4.24033H37.1017L32.9205 9.92061L28.7428 4.24033H26.827L31.9524 11.2018L26.332 18.8613H28.2577L32.9233 12.5224L37.5918 18.8613H39.5153Z",
    fill: "#177D3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.794 11.7604C23.794 18.2557 18.4683 23.5207 11.8989 23.5207C5.32952 23.5207 0.00390625 18.2557 0.00390625 11.7604C0.00390625 5.26568 5.32952 0 11.8989 0C18.4683 0 23.794 5.26498 23.794 11.7604Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.794 11.7604C23.794 18.2557 18.4683 23.5207 11.8989 23.5207C5.32952 23.5207 0.00390625 18.2557 0.00390625 11.7604C0.00390625 5.26568 5.32952 0 11.8989 0C18.4683 0 23.794 5.26498 23.794 11.7604Z",
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.794 11.7604C23.794 18.2557 18.4683 23.5207 11.8989 23.5207C5.32952 23.5207 0.00390625 18.2557 0.00390625 11.7604C0.00390625 5.26568 5.32952 0 11.8989 0C18.4683 0 23.794 5.26498 23.794 11.7604Z",
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.794 11.7604C23.794 18.2557 18.4683 23.5207 11.8989 23.5207C5.32952 23.5207 0.00390625 18.2557 0.00390625 11.7604C0.00390625 5.26568 5.32952 0 11.8989 0C18.4683 0 23.794 5.26498 23.794 11.7604Z",
    fill: "url(#paint2_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88154 6.60895C7.56794 8.20106 2.06604 14.6718 2.55397 19.0469C2.89383 19.477 3.26824 19.8803 3.6638 20.2597C3.60598 16.9105 7.53621 13.3264 10.6034 10.621L8.88083 6.60895H8.88154Z",
    fill: "#00A54D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8807 6.60901C7.5679 8.20105 2.06595 14.6715 2.55399 19.0468C2.89355 19.4773 3.26793 19.8802 3.66361 20.2592C3.60607 16.9107 7.53594 13.3258 10.6034 10.6209L8.8807 6.60901Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.651 1.75793C4.96809 2.17108 4.32862 2.65123 3.74219 3.19119C5.62898 3.54968 7.52145 5.21087 8.55933 6.58697C9.46294 7.99976 9.95382 9.29471 10.5918 10.6313C11.0356 10.252 11.4846 9.87862 11.9386 9.51135L11.9358 3.70634C10.5299 2.83269 8.20627 1.68312 5.67302 1.75793C5.66734 1.76146 5.65597 1.7544 5.651 1.75793Z",
    fill: "#02A74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.651 1.75793C4.96809 2.17108 4.32862 2.65123 3.74219 3.19119C5.62898 3.54968 7.52145 5.21087 8.55933 6.58697C9.46294 7.99976 9.95382 9.29471 10.5918 10.6313C11.0356 10.252 11.4846 9.87862 11.9386 9.51135L11.9358 3.70634C10.5299 2.83269 8.20627 1.68312 5.67302 1.75793C5.66734 1.76146 5.65597 1.7544 5.651 1.75793Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.92 6.61392C16.2287 8.20745 21.7123 14.6838 21.2258 19.0618C20.8873 19.4919 20.5143 19.8959 20.1202 20.2759C20.1773 16.9239 16.2604 13.3363 13.2031 10.6288L14.92 6.61322V6.61392Z",
    fill: "#00A54D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9177 6.61328C16.2261 8.20667 21.7099 14.6834 21.2235 19.0617C20.8831 19.4911 20.5136 19.8968 20.1175 20.2758C20.1749 16.9237 16.258 13.3365 13.2007 10.6285L14.9177 6.61328Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1398 1.75824C18.8204 2.17214 19.4579 2.65267 20.043 3.19271C18.1624 3.55151 16.2755 5.21411 15.2418 6.59138C14.3411 8.00537 13.8512 9.30141 13.2153 10.6398C12.7849 10.2733 12.3473 9.90035 11.8729 9.51895L11.8757 3.7083C13.2769 2.83392 15.5929 1.68337 18.1178 1.75824C18.1228 1.76177 18.1348 1.7547 18.1398 1.75824Z",
    fill: "#02A74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1398 1.75824C18.8204 2.17214 19.4579 2.65267 20.043 3.19271C18.1624 3.55151 16.2755 5.21411 15.2418 6.59138C14.3411 8.00537 13.8512 9.30141 13.2153 10.6398C12.7849 10.2733 12.3473 9.90035 11.8729 9.51895L11.8757 3.7083C13.2769 2.83392 15.5929 1.68337 18.1178 1.75824C18.1228 1.76177 18.1348 1.7547 18.1398 1.75824Z",
    fill: "url(#paint6_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6858 10.4999) rotate(90) scale(17.1363 15.2168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6858 10.4999) rotate(90) scale(17.1363 15.2168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6858 10.4999) rotate(90) scale(17.1363 15.2168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7.59722,
    y1: 15.0576,
    x2: 4.80939,
    y2: 11.7439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97CA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97CA43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 7.47533,
    y1: 7.19043,
    x2: 10.0122,
    y2: 1.48473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97CA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97CA43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 16.2389,
    y1: 15.0218,
    x2: 13.443,
    y2: 11.7253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97CA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97CA43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 16.339,
    y1: 6.89979,
    x2: 18.5244,
    y2: 3.32223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97CA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97CA43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 23.52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbox);
export default __webpack_public_path__ + "static/media/xbox.d7ae02c384c2057bcea554e47df7f669.svg";
export { ForwardRef as ReactComponent };